import angular from 'angular';
import fastpathUserList from '../Components/userRestrictions/fastpathUserList/fastpathUserList.component';
import userRestrictionsFactory from '../Components/userRestrictions/userRestrictions.factory';

export default angular
    .module('app.systemConfiguration.userRestrictions', [])
    .component('fastpathUserList', fastpathUserList)
    .factory('userRestrictionsDataService', userRestrictionsFactory)
    .name;